@if (tabs) {
    <div class="widget-tab-bar">
        <ds-tabs-group
            indicator="underline"
            fullWidthTabs="false"
            size="small"
            variant="horizontal"
            class="arrow-alignment"
            scrollSpeed="slow"
            [scrollable]="true"
            [activeTab]="active"
            (activeTabChange)="selected($event)">
            @for (tab of tabs; track tab.id) {
                <ds-tab [name]="tab.attribute ?? ''" [disabled]="tab.disabled">
                    <ng-template let-selected dsTabHeader>
                        @if (tab.icon) {
                            @if (tab.display === display.Logo) {
                                <ms-competition-logo
                                    class="icon"
                                    [sportId]="tab.sportId"
                                    [leagueId]="tab.itemId"
                                    [fallbackIcon]="tab.icon"
                                    [isLogoOverrideEnabled]="true" />
                            } @else {
                                <vn-icon class="icon" size="16" [name]="tab.icon" />
                            }
                        }
                        {{ tab.title }}
                        @if (!!tab.count) {
                            @if (tab.showSignPost) {
                                <ms-priceboost-count-signpost [count]="tab.count.toString()" />
                            } @else {
                                <ds-notification-bubble
                                    msThemedNotification
                                    size="medium"
                                    [isSelected]="selected"
                                    [selectedVariant]="selectedTabBubbleVariant"
                                    [themedVariant]="variant"
                                    [inverse]="false">
                                    {{ tab.count }}
                                </ds-notification-bubble>
                            }
                        }
                    </ng-template>
                </ds-tab>
                <ng-template #dsTabsLeftArrow>
                    <ds-arrow size="small" direction="left" />
                </ng-template>
                <ng-template #dsTabsRightArrow>
                    <ds-arrow size="small" direction="right" />
                </ng-template>
            }
            <ds-divider />
        </ds-tabs-group>
    </div>
}
